import { Dropdown, Popover } from 'antd'
import React, { useState } from 'react'
import { CaretDownOutlined, DownloadOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'
import { MenuProps } from 'antd/lib'
import usePersistDataStore from '@/stores/persistData'
import logo from '@/assets/image/logo.svg'
import qrCode from '@/assets/image/QRCode.png'
import loginBg from '@/assets/image/login.svg'
import ForgotPasswordForm from './components/ForgotPasswordForm'
import LoginForm from './components/LoginForm'

const Login: React.FC = () => {
  const { t } = useTranslation()
  const lang = usePersistDataStore(state => state.lang)
  const setLang = usePersistDataStore(state => state.setLang)
  const [isForgot, setIsForgot] = useState(false)

  const languageList: MenuProps['items'] = [
    { key: 'en_US', label: 'English', onClick: () => setLang('en_US') },
    { key: 'zh_CN', label: '中文', onClick: () => setLang('zh_CN') },
  ]

  const content = (
    <div className='login-popover'>
      <div className='popover-title'>{t('user.downloadApp')}</div>
      <div className='popover-subTitle'>myNoark</div>
      <div className='popover-content'>{t('user.appTips')}</div>
      <div className='popover-qrcode'>
        <img src={qrCode} className='popover-qrcode-img' />
      </div>
      <div className='popover-tip'>{t('user.scanApp')}</div>
    </div>
  )

  return (
    <div className='login'>
      <div className='login-header'>
        <div className='login-header-logo'>
          <img src={logo} />
        </div>
        <div className='login-header-right'>
          <Popover placement='bottomRight' content={content} trigger='click'>
            <div className='login-header-right-download'>
              <DownloadOutlined />
              <span>{t('user.downloadApp')}</span>
            </div>
          </Popover>
          <div className='header-separator'></div>
          <Dropdown menu={{ items: languageList }} placement='bottom'>
            <div className='login-header-right-language'>
              <span>{lang === 'en_US' ? 'English' : '简体中文'}</span>
              <CaretDownOutlined />
            </div>
          </Dropdown>
        </div>
      </div>
      <div className='login-content'>
        <div className='login-content-left'>
          <img style={{ width: '100%', height: '100%' }} src={loginBg} />
        </div>
        <div className='login-content-right'>
          {isForgot ? (
            <ForgotPasswordForm onClickBack={() => setIsForgot(false)} />
          ) : (
            <LoginForm onClickForgot={() => setIsForgot(true)} />
          )}
        </div>
      </div>
    </div>
  )
}

export default Login
